import { RulesView } from "@/components/rules/rules-view"

/**
 * Вкладка Local rules — наши собственные правила, которых у SEON нет вовсе.
 *
 * Пока оно здесь одно: «значение поля в чёрном списке» (AMEND-13 §3). До него
 * правило ЧС существовало только кодом прогона и в каталоге не значилось —
 * переопределить на стенде было нечего. Теперь это обычная строка каталога:
 * тот же список, та же карточка условия, тот же прогон.
 *
 * Своя вкладка, а не строка среди Custom rules: `custom` целиком
 * перезаписывается следующей выгрузкой SEON, и наше правило либо стёрлось бы,
 * либо столкнулось `seon_id` с чужим. Рядом с выгрузкой оно к тому же читалось
 * бы как её часть.
 *
 * `Export all` тут нет намеренно: формат выгрузки принадлежит SEON, и своё
 * правило в нём выглядело бы правилом SEON. Источник этих строк — `rules/`
 * в репозитории, а не кнопка на экране.
 */
export function LocalRulesTab() {
  return (
    <RulesView
      type="local"
      title="Local rules"
      defaultSort={{ sort: "seon_id", order: "asc" }}
    />
  )
}
